const INSTAGRAM_USERNAME_PATTERN = /^[a-zA-Z0-9._]{1,30}$/;

export const normalizeInstagramUsername = value => {
  const username = String(value || '')
    .trim()
    .replace(/^@+/, '');

  return INSTAGRAM_USERNAME_PATTERN.test(username) ? username : '';
};

export const instagramProfileUrl = value => {
  const username = normalizeInstagramUsername(value);
  return username ? `https://www.instagram.com/${username}/` : '';
};
